module.exports = __webpack_public_path__ + "static/dexTrade-c812a1957d13e8a642eb4068ede8825b.svg";